import axios from 'axios';
import {HttpUtils} from "@/api/common/HttpUtils";
import {MarketingMaterialItem} from "../models/MarketingMaterialItem";

export class MarketingMaterialService {

    constructor(auth){

        this._auth = auth;

        this._baseUrl = `${process.env.VUE_APP_API_URL}/v1/marketing-materials`;
        this._headers = HttpUtils.getHttpHeaders(this._auth, 'text/json');

    }

    get baseUrl(){
        return this._baseUrl;
    }

    get headers(){
        return this._headers;
    }

    getDownloadUrl(itemId){
          return `${this._baseUrl}/${itemId}/download?session-id=${HttpUtils.getSessionId(this._auth)}&instance-id=${HttpUtils.getInstanceId()}`;
    }

    save(marketingMaterialItem){

        if (!(marketingMaterialItem instanceof MarketingMaterialItem)){
            throw new Error('[e943691] Expected argument type is MarketingMaterialItem')
        }

        let companyId = marketingMaterialItem.companyId;
        let fileId = marketingMaterialItem.fileId;

        if (!companyId || companyId === ''){
            throw new Error('[e982952] company id not defined');
        }

        if (!fileId || fileId === ''){
            throw new Error('[e653995] file id not defined');
        }

        let url = `${this._baseUrl}/companies/${companyId}/save/${fileId}`;

        let payload = {
            name: marketingMaterialItem.name,
            description : marketingMaterialItem.description
        };

        return new Promise((resolve, reject) => {
            HttpUtils.post(url, this._auth, payload).then(data => {
                marketingMaterialItem.setFile(data.itemId, data.uri, data.fileName);
                resolve(marketingMaterialItem);
            }).catch(error => {
                reject(error);
            });
        });

    }

    getItems(companyId){
        if (!companyId || companyId === ''){
            throw new Error('[e982952] company id not defined');
        }

        let url = `${this._baseUrl}/companies/${companyId}?inactives=1`;

        return new Promise((resolve, reject) =>{
           HttpUtils.get(url, this._auth).then(data => {

               let list = [];
               data.forEach(function(item){

                  let marketingMaterialItem = new MarketingMaterialItem(companyId);
                   marketingMaterialItem.name = item.name;
                   marketingMaterialItem.description = item.description;
                   marketingMaterialItem.isActive = item.isActive;
                   marketingMaterialItem.setFile(item.itemId, item.uri, item.filename, item.mimeType);
                   list.push(marketingMaterialItem);

               });

               resolve(list);

           }).catch(error => {
               reject(error);
           });
        });
    }

    changeActiveStatus(itemId, isActive){
        if (itemId == null){
            throw new Error('[e921335] itemId is required');
        }

        if (isActive == null){
            throw new Error('[e496196] isActive argument is required');
        }
        let action = '';
        if (isActive){
            action = 'activate';
        }
        else{
            action = 'deactivate'
        }

        let url = `${this._baseUrl}/${itemId}/${action}`;

        return new Promise((resolve, reject) =>{
            HttpUtils.put(url, this._auth, null).then(data => {
                resolve();

            }).catch(error => {
                reject(error);
            });
        });
    }

    deleteItem(itemId){
        if (!itemId){
            throw new Error('[e706167] itemId required is required');
        }


        let url = `${this._baseUrl}/${itemId}`;

        return new Promise((resolve, reject) =>{
            HttpUtils.delete(url, this._auth).then(data => {
                resolve();

            }).catch(error => {
                reject(error);
            });
        });
    }

    existFile(itemId) {
        if (!itemId) {
            throw new Error('[e154854] itemId required is required');
        }

        let url = `${this._baseUrl}/${itemId}/exists-file`;
        return new Promise((resolve, reject) => {
            HttpUtils.head(url, this._auth).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });

    }



}